package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MindMapNodeQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-26_953_865, arrayOf("mind_map_node"), driver, "MindMapNode.sq",
      "selectAll",
      "SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE is_deleted = 0 ORDER BY map_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectAll(): Query<Mind_map_node> = selectAll { id, map_id, parent_id, text, color,
      source_kind, source_id, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Mind_map_node(
      id,
      map_id,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectById(id: String): Query<Mind_map_node> = selectById(id) { id_, map_id, parent_id,
      text, color, source_kind, source_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Mind_map_node(
      id_,
      map_id,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByMap(map_id: String, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByMapQuery(map_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByMap(map_id: String): Query<Mind_map_node> = selectByMap(map_id) { id, map_id_,
      parent_id, text, color, source_kind, source_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Mind_map_node(
      id,
      map_id_,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByMapAnyState(map_id: String, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByMapAnyStateQuery(map_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByMapAnyState(map_id: String): Query<Mind_map_node> =
      selectByMapAnyState(map_id) { id, map_id_, parent_id, text, color, source_kind, source_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node(
      id,
      map_id_,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectChildren(parent_id: String?, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectChildrenQuery(parent_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectChildren(parent_id: String?): Query<Mind_map_node> = selectChildren(parent_id) {
      id, map_id, parent_id_, text, color, source_kind, source_id, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node(
      id,
      map_id,
      parent_id_,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectRoots(map_id: String, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectRootsQuery(map_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectRoots(map_id: String): Query<Mind_map_node> = selectRoots(map_id) { id, map_id_,
      parent_id, text, color, source_kind, source_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Mind_map_node(
      id,
      map_id_,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun countByMap(map_id: String): Query<Long> = CountByMapQuery(map_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-130_169_816, arrayOf("mind_map_node"), driver, "MindMapNode.sq",
      "selectDirty",
      "SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectDirty(): Query<Mind_map_node> = selectDirty { id, map_id, parent_id, text, color,
      source_kind, source_id, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Mind_map_node(
      id,
      map_id,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Mind_map_node> = selectByIdAnyState(id) { id_,
      map_id, parent_id, text, color, source_kind, source_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Mind_map_node(
      id_,
      map_id,
      parent_id,
      text,
      color,
      source_kind,
      source_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_305_703_545, """
        |INSERT INTO mind_map_node(id, map_id, parent_id, text, color, source_kind, source_id, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, map_id)
          bindString(2, parent_id)
          bindString(3, text)
          bindString(4, color)
          bindString(5, source_kind)
          bindString(6, source_id)
          bindLong(7, order_index)
          bindLong(8, created_at)
          bindLong(9, updated_at)
        }
    notifyQueries(-1_305_703_545) { emit ->
      emit("mind_map_node")
    }
  }

  public fun update(
    map_id: String,
    parent_id: String?,
    text: String,
    color: String?,
    source_kind: String?,
    source_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-960_757_353, """
        |UPDATE mind_map_node
        |SET map_id = ?, parent_id = ?, text = ?, color = ?, source_kind = ?, source_id = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 9) {
          bindString(0, map_id)
          bindString(1, parent_id)
          bindString(2, text)
          bindString(3, color)
          bindString(4, source_kind)
          bindString(5, source_id)
          bindLong(6, order_index)
          bindLong(7, updated_at)
          bindString(8, id)
        }
    notifyQueries(-960_757_353) { emit ->
      emit("mind_map_node")
    }
  }

  public fun setText(
    text: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_794_259_551,
        """UPDATE mind_map_node SET text = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, text)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_794_259_551) { emit ->
      emit("mind_map_node")
    }
  }

  public fun setColor(
    color: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(197_115_247,
        """UPDATE mind_map_node SET color = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, color)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(197_115_247) { emit ->
      emit("mind_map_node")
    }
  }

  public fun move(
    parent_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_866_915_871,
        """UPDATE mind_map_node SET parent_id = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        4) {
          bindString(0, parent_id)
          bindLong(1, order_index)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(1_866_915_871) { emit ->
      emit("mind_map_node")
    }
  }

  public fun setOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(208_278_874,
        """UPDATE mind_map_node SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(208_278_874) { emit ->
      emit("mind_map_node")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(225_366_083,
        """UPDATE mind_map_node SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(225_366_083) { emit ->
      emit("mind_map_node")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_613_243_264,
        """UPDATE mind_map_node SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_613_243_264) { emit ->
      emit("mind_map_node")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(45_303_876, """DELETE FROM mind_map_node WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(45_303_876) { emit ->
      emit("mind_map_node")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_428_259_701,
        """UPDATE mind_map_node SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_428_259_701) { emit ->
      emit("mind_map_node")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-835_528_516,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMapNode.sq:selectById"
  }

  private inner class SelectByMapQuery<out T : Any>(
    public val map_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-131_576_357,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE map_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, map_id)
    }

    override fun toString(): String = "MindMapNode.sq:selectByMap"
  }

  private inner class SelectByMapAnyStateQuery<out T : Any>(
    public val map_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_435_347_712,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE map_id = ?""",
        mapper, 1) {
      bindString(0, map_id)
    }

    override fun toString(): String = "MindMapNode.sq:selectByMapAnyState"
  }

  private inner class SelectChildrenQuery<out T : Any>(
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, parent_id)
    }

    override fun toString(): String = "MindMapNode.sq:selectChildren"
  }

  private inner class SelectRootsQuery<out T : Any>(
    public val map_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-117_064_665,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE map_id = ? AND parent_id IS NULL AND is_deleted = 0 ORDER BY created_at""",
        mapper, 1) {
      bindString(0, map_id)
    }

    override fun toString(): String = "MindMapNode.sq:selectRoots"
  }

  private inner class CountByMapQuery<out T : Any>(
    public val map_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-240_849_020,
        """SELECT COUNT(*) FROM mind_map_node WHERE map_id = ? AND is_deleted = 0""", mapper, 1) {
      bindString(0, map_id)
    }

    override fun toString(): String = "MindMapNode.sq:countByMap"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(175_664_865,
        """SELECT mind_map_node.id, mind_map_node.map_id, mind_map_node.parent_id, mind_map_node.text, mind_map_node.color, mind_map_node.source_kind, mind_map_node.source_id, mind_map_node.order_index, mind_map_node.created_at, mind_map_node.updated_at, mind_map_node.is_deleted, mind_map_node.deleted_at, mind_map_node.synced_at FROM mind_map_node WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMapNode.sq:selectByIdAnyState"
  }
}
